module.exports = __webpack_public_path__ + "media/images/flags/MY-d4db793e37769ec8df9a12b7b1a29a4a.svg";